export const state = () => ({
    lastSearchQuery: null,
});

export const mutations = {
    setLastSearchQuery(state, payload) {
        state.lastSearchQuery = payload;
    },
};
